<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .m-t-sm.pull-right(v-show="!onLoading('fetch-stock-receive')")
            .dropdown.inline
                button.md-btn.md-raised.m-b-sm.white.m-r-sm.w-xs.dropdown-toggle(
                    data-toggle="dropdown",
                    :disabled="isLoading",
                    aria-expanded="false"
                ) Action
                .dropdown-menu
                    a.dropdown-item(:href="printUrl", target="_blank")
                        i.material-icons.m-r-sm print
                        | Print

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Stock Request
                li.breadcrumb-item.active {{ stockRequest.reference_id }}

    .padding(v-show="!onLoading('fetch-stock-request')")
        stock-request-info
        stock-request-stocks

        .box.dker(v-show="!onLoading('fetch-stock-request') && !hasFinalized && !isDeclined")
            .box-body
                stock-request-action
</template>

<script>
import stockRequestMixin from './stock-request-mixin';
import stockRequestAction from './stock-request-edit-action.vue';
import stockRequestInfo from './stock-request-edit-info.vue';
import stockRequestStocks from './stock-request-edit-stocks.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stockRequestStocks, stockRequestInfo, stockRequestAction },

    mixins: [stockRequestMixin],

    computed: {
        printUrl() {
            return Laroute.route('stock_requests.print', {
                id: this.stockRequest.id,
            });
        },
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.getStockRequest(id);
            }

            this.errors.clear();
        },
    },

    created() {
        this.getStockRequest(this.$route.params.id);
    },

    methods: {
        ...mapActions('stockRequest', ['getStockRequest']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-edit.vue